import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

import { MeasureInsightTableConnected } from '@grow-therapy-team/seedling-components';

export function MeasuresSectionContent({
  hasCompletedMeasureResponses,
  clientUserShortId,
  providerShortId,
  onClick,
}: {
  hasCompletedMeasureResponses: boolean;
  clientUserShortId: string;
  providerShortId: string;
  onClick: () => void;
}): JSX.Element {
  const t = useTranslate();

  return (
    <div className='flex flex-col rebrand:gap-350'>
      {hasCompletedMeasureResponses && (
        <MeasureInsightTableConnected
          clientUserShortId={clientUserShortId}
          providerShortId={providerShortId}
          isProvider
          isShownWithinPaperworkFlow={false}
          timezone={Intl.DateTimeFormat().resolvedOptions().timeZone}
        />
      )}
      <Button use='link' onClick={onClick}>
        {t('telehealth-core:providerIntersessionSummary.viewMeasures')}
      </Button>
    </div>
  );
}
